<template>
  <TypesContext>
    <RouterView></RouterView>
  </TypesContext>
</template>

<script setup lang="ts">
import TypesContext from '@/components/deepbox/types/TypesContext.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.deepbox.types',
  },
})
</script>
